"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.5 42H34.5V34.4355C34.4988 33.2595 34.0311 32.132 33.1995 31.3004C32.368 30.4689 31.2405 30.0012 30.0645 30H17.9355C16.7595 30.0012 15.632 30.4689 14.8004 31.3004C13.9689 32.132 13.5012 33.2595 13.5 34.4355V42H10.5V34.4355C10.5024 32.4642 11.2865 30.5743 12.6804 29.1804C14.0743 27.7865 15.9642 27.0024 17.9355 27H30.0645C32.0358 27.0024 33.9256 27.7865 35.3196 29.1804C36.7135 30.5743 37.4976 32.4642 37.5 34.4355V42Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 24C22.22 24 20.4799 23.4722 18.9999 22.4832C17.5198 21.4943 16.3663 20.0887 15.6851 18.4442C15.0039 16.7996 14.8257 14.99 15.1729 13.2442C15.5202 11.4984 16.3774 9.89471 17.636 8.63604C18.8947 7.37737 20.4984 6.5202 22.2442 6.17294C23.99 5.82567 25.7996 6.0039 27.4442 6.68509C29.0887 7.36628 30.4943 8.51983 31.4832 9.99987C32.4722 11.4799 33 13.22 33 15C32.9976 17.3862 32.0486 19.674 30.3613 21.3613C28.674 23.0486 26.3862 23.9976 24 24ZM24 9C22.8133 9 21.6533 9.3519 20.6666 10.0112C19.6799 10.6705 18.9109 11.6075 18.4567 12.7039C18.0026 13.8003 17.8838 15.0067 18.1153 16.1705C18.3468 17.3344 18.9182 18.4035 19.7574 19.2426C20.5965 20.0818 21.6656 20.6532 22.8295 20.8847C23.9933 21.1162 25.1997 20.9974 26.2961 20.5433C27.3925 20.0892 28.3295 19.3201 28.9888 18.3334C29.6481 17.3467 30 16.1867 30 15C30 13.4087 29.3679 11.8826 28.2426 10.7574C27.1174 9.63214 25.5913 9 24 9Z",
    fill: fill
  }));
};

exports["default"] = _default;